/* CMS: dane z panelu Shopify (AV_SHOP_PRODUCT) nadpisują katalog; katalog jest zapasem, gdy pole w Shopify puste. Musi działać po pdp-catalog.js i przed pdp-product.js. */
(function () {
  'use strict';
  var S = window.AV_SHOP_PRODUCT, D = window.ALTIVEST_PRODUCT_DATA;
  var root = document.querySelector('[data-product-page]');
  if (!S || !D || !root || !Array.isArray(D.products)) return;
  var model = root.dataset.model || S.handle;
  var norm = function (u) { return String(u || '').split('?')[0].split('/').pop().replace(/^pdp-(img|card)-/, '').toLowerCase(); };
  var media = (S.media || []).filter(function (m) { return m && m.url; });
  // CMS: motywy z metaobiektu motyw_haftu (nazwa, kategoria, obraz, kolejność, aktywny). Pole puste = zostaje katalog. Nowy wpis = nowy motyw dla wszystkich produktów z motywami.
  (function () {
    var M = window.AV_SHOP_MOTIFS; if (!Array.isArray(M) || !M.length || !Array.isArray(D.motifs) || !D.motifs.length) return;
    var byId = {}; D.motifs.forEach(function (m) { byId[m.id] = m; });
    var tpl = D.motifs[0];
    M.forEach(function (x) {
      var m = byId[x.id];
      if (!m) {
        if (!x.active || !x.url || !x.name) return;
        m = { id: x.id, name: x.name, category: x.category || 'Inne', image: x.url, assetSha256: '', models: (tpl.models || []).slice(), placements: (tpl.placements || []).slice(), status: 'cms', threadPolicy: tpl.threadPolicy || 'fixed' };
        D.motifs.push(m); byId[x.id] = m;
      }
      if (x.name) m.name = x.name;
      if (x.category) m.category = x.category;
      if (x.url) m.image = x.url;
      m._o = Number(x.order) || 9999;
      if (!x.active) { m.models = []; m._off = true; }
    });
    D.motifs.forEach(function (m, i) { m._i = i; });
    D.motifs.sort(function (a, b) { return ((a._o || 9999) - (b._o || 9999)) || (a._i - b._i); });
  })();
  // CMS: karty "Inna baza" (i ceny) z danych panelu dla wszystkich produktów
  (function () {
    var A = window.AV_SHOP_ALL; if (!A) return;
    var H2 = { 'CZA 5P': 'gabriela-cap', 'PORA210WK': 'altivest-polo-worker' };
    D.products.forEach(function (x) {
      var a = A[x.handle && x.handle !== x.model ? x.handle : (H2[x.model] || x.handle)]; if (!a) { if (Object.keys(A).length < 50) x._offline = true; return; }
      if (a.title) x.shortTitle = a.title;
      x.priceMinor = Number(a.price) > 0 ? Number(a.price) : null; x.currency = x.priceMinor ? 'PLN' : null;
      if (a.img) { x.cardImage = a.img; }
      if (a.url) x.productUrl = a.url;
    });
  })();
  // CMS: kolory i rozmiary z opcji produktu w panelu; tabela rozmiarów z metafielda altivest.tabela_rozmiarow; opis haftu z altivest.haft_opis.
  var toks = function (x) { return String(x).toLowerCase().split(' · ').map(function (t) { return t.trim(); }).sort().join('|'); };
  var applyPanelData = function (p) {
    p.manufacturer = p.manufacturer || {}; var m = p.manufacturer;
    (S.options || []).forEach(function (o) {
      if (!o.values || !o.values.length) return;
      if (o.name === 'Rozmiar') { m.sizes = o.values.slice(); }
      if (o.name === 'Kolor') {
        var cat = {}; (m.colors || []).forEach(function (c) { cat[toks(c)] = c; });
        m.colors = o.values.map(function (v) { return cat[toks(v)] || v; });
      }
    });
    if (S.tabela) {
      var L = String(S.tabela).split(/\r?\n/).map(function (t) { return t.trim(); }).filter(Boolean);
      var cells = function (l) { return l.split('|').map(function (c) { return c.trim(); }); };
      if (L.length > 1) {
        var h = cells(L[0]), rows = [];
        L.slice(1).forEach(function (l) { var c = cells(l); var lab = c[0], parts = lab.split(' — '); rows.push({ code: parts.length > 1 ? parts[0] : '', label: parts.length > 1 ? parts.slice(1).join(' — ') : lab, values: c.slice(1) }); });
        m.table = { sizes: h.slice(1), rows: rows, unit: (h[0].match(/\(([^)]+)\)/) || [0, 'cm'])[1], tolerance: null };
      }
    }
    if (S.haftOpis) {
      var hd = Array.prototype.filter.call(document.querySelectorAll('details'), function (d) { var sm = d.querySelector('summary'); return sm && /^(Haft i personalizacja|Personalizacja)$/.test(sm.textContent.trim()); });
      hd.forEach(function (d) { var ps = Array.prototype.slice.call(d.querySelectorAll('p')); var pp = ps.filter(function (x) { return /^Wybierz miejsce haftu/.test(x.textContent.trim()); })[0] || ps[ps.length - 1]; if (pp) pp.textContent = S.haftOpis; });
    }
  };
  var p = D.products.find(function (x) { return x.model === model; });
  var cp = ((window.ALTIVEST_COLOR_PHOTOS || {}).products || {})[model];
  var priceMinor = Number(S.price) || 0;
  if (!p) {
    // nowy produkt bez wpisu w katalogu: ogólny szablon (nazwa, opis, galeria, Kolor/Rozmiar z wariantów Shopify)
    if (!media.length && !S.title) return;
    p = { model: model, title: S.title, shortTitle: S.title, handle: S.handle, image: media[0] ? media[0].url : null,
      imageAlt: (media[0] && media[0].alt) || S.title, imageWidth: media[0] ? media[0].w : null, imageHeight: media[0] ? media[0].h : null,
      priceMinor: priceMinor || null, currency: priceMinor ? 'PLN' : null, available: null, shopifyVariantId: null, approvalStatus: 'unknown',
      area: 'produkty', variants: [], modelKind: 'shop_product', manufacturer: { facts: [], sizes: [], colors: [] }, editorial: S.description || '', gallery: [] };
    D.products.push(p); applyPanelData(p); if (S.szczegoly) { var fl0 = String(S.szczegoly).split(/\r?\n/).map(function (t) { return t.trim(); }).filter(Boolean); if (fl0.length) { p.manufacturer.facts = fl0; } }
    p.gallery = media.map(function (m, i) { return { image: m.url, label: m.alt || (S.title + ', zdjęcie ' + (i + 1)), width: m.w, height: m.h }; });
    if (!priceMinor) p.inquiryOnly = true;

// Personalizacja ręcznika.
if (S.handle === 'recznik' && S.haftTryb !== 'bez haftu') {
  p.profileId = 'preview-recznik';
  p.profileVersion = 'preview-recznik-v1';
  p.profileStatus = 'draft';
  p.frontOnly = true;
  p.noBackPlacement = true;
  p.chestLabel = 'Przód ręcznika';

  // Orientacyjne pole podglądu, do sprawdzenia na zdjęciu.
  p.previewBox = [50, 65, 30, 20];

  if (S.haftTryb !== 'tylko napis') {
    (D.motifs || []).forEach(function(m) {
      var models = m.models || [];

      // Na początek ten sam zestaw motywów co na torbie.
      if (
        !m._off &&
        models.indexOf('Torba z długimi uchwytami') >= 0 &&
        models.indexOf(model) < 0
      ) {
        models.push(model);
      }
    });
  }
}

return;

  }
  // CMS: ustawienia haftu z metafieldów produktu (altivest.haft_tryb / haft_miejsca). Puste pole = zostaje ustawienie z katalogu.
  var tryb = S.haftTryb, miejsca = S.haftMiejsca;
  if (tryb === 'bez haftu') { p.profileId = null; }
  else if (tryb === 'tylko napis' && p.profileId) { (D.motifs || []).forEach(function (m) { var i = (m.models || []).indexOf(model); if (i > -1) m.models.splice(i, 1); }); }
  else if (tryb === 'motyw i napis' && p.profileId) { (D.motifs || []).forEach(function (m) { if (!m._off && (m.models || []).indexOf(model) < 0) m.models.push(model); }); }
  if (Array.isArray(miejsca) && miejsca.length && p.profileId) { p.noBackPlacement = miejsca.indexOf('plecy') < 0; }
  applyPanelData(p);
  if (S.title) { p.shortTitle = S.title; }
  // CMS: Szczegóły i Materiał z metafielda altivest.szczegoly (jedna linia = jeden akapit). Puste = zapas z katalogu.
  if (S.szczegoly) { var fl = String(S.szczegoly).split(/\r?\n/).map(function (t) { return t.trim(); }).filter(Boolean); if (fl.length) { p.manufacturer = p.manufacturer || {}; p.manufacturer.facts = fl; } }
  p.priceMinor = priceMinor || null; p.currency = priceMinor ? 'PLN' : null;
  if (S.description) { p.editorial = S.description; }
  if (!priceMinor) { p.inquiryOnly = true; }
  if (!media.length) return;
  // produkt bez konfiguratora haftu: główne zdjęcie PDP = pierwsze zdjęcie z panelu (jak na karcie produktu). Przy produktach z haftem zdjęcie główne jest bazą podglądu haftu, więc zostaje z katalogu.
  if (!p.profileId) { p.image = media[0].url; p.imageAlt = media[0].alt || p.title; p.imageWidth = media[0].w; p.imageHeight = media[0].h; }
  // galeria: kolejność i zestaw zdjęć z panelu. Zdjęcia systemowe (kolory, karta) nie trafiają do galerii, nowe tak.
  var catG = {}; (p.gallery || []).forEach(function (g) { catG[norm(g.image)] = g; });
  var sys = {}; [p.image, p.backImage, p.leadImage, p.cardImage].forEach(function (u) { if (u) sys[norm(u)] = 1; });
  Object.keys(S.colorImages || {}).forEach(function (k) { sys[norm(S.colorImages[k])] = 1; });
  var isColor = function (n) { return /^(ai-c-|rc-)/.test(n); };
  var g2 = [];
  media.forEach(function (m, i) {
    var n = norm(m.url), c = catG[n];
    if (c) { g2.push(Object.assign({}, c, { image: m.url })); delete catG[n]; }
    else if (i > 0 && !sys[n] && !isColor(n)) g2.push({ image: m.url, label: m.alt || ((S.title || p.title) + ', zdjęcie ' + (i + 1)), width: m.w, height: m.h });
  });
  p.gallery = g2;
})();
